import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}
h1{
  color: ${props => props.theme.colors.white}
}

table{
  width: 100%;
  border-left: none;
  margin-left: 0px;
}
table thead {
  color: ${props => props.theme.colors.white};
  height: ${props => props.theme.spacing.spacing_09};
  background-color: ${props => props.theme.colors.secondary};
}


td, th{
  vertical-align: middle !important;
  border-left: none;
}

tbody tr{
  height: ${props => props.theme.spacing.spacing_09};
  border-left: none;
}

button{
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.black};
  height: 40px;
}

.center{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.table-title{
  display: flex;
  padding-bottom: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 0px;
  justify-content: space-between;
  color: ${p => p.theme.colors.white};
  background-color: ${props => props.theme.colors.secondary};
  height: ${props => props.theme.spacing.spacing_09};
}

.action {
  width: 100%;
  height: 100%;
  display:flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.black};

}
.icon {
  width: ${props => props.theme.spacing.spacing_08};
  height:  ${props => props.theme.spacing.spacing_06};
}
.icon-action-disabled {
  filter: saturate(70%) brightness(70%);
  color: red;
  pointer-events: none;
}
.icon-action{
  color: green;
}
`
